import script from "./NewUserWelfare.vue?vue&type=script&setup=true&lang=js"
export * from "./NewUserWelfare.vue?vue&type=script&setup=true&lang=js"

import "./NewUserWelfare.vue?vue&type=style&index=0&id=675ec3e6&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675ec3e6"]])

export default __exports__